import { isQuestionMode, isQuestionSet } from 'common/util/shared/sharedUtils';
import { FeatureTypesWithCurs } from 'common/services/permissions/typings';
import {
    hasCURAccessForAction,
    hasQuestionTestCasesAccess,
    hasQuestionSetTemplateWriteAccess,
} from 'common/services/permissions/commonPermissionService';
import { defaultScheme as authorEditScheme } from '../../docs/workspace-scheme/workspace-scheme-author-default';
import { defaultScheme as authorEditQuestionSheme } from '../../docs/workspace-scheme/workspace-scheme-author-question';
import { defaultScheme as authorEditNewScheme } from '../../docs/workspace-scheme/workspace-scheme-author-2025';
import { defaultScheme as authorNewEditQuestionSheme } from '../../docs/workspace-scheme/workspace-scheme-author-question-2025';
import permissionService from './permissions/PermissionService';
import newAuthorUIService from './newAuthorUIService';

const workspaceSchemeLoadingService = {
    async fetchWorkspaceScheme(isTemplate = false, isIBTemplate = false) {
        const isXTMEnabled = window.marketplaceProperties.ENABLE_ITEM_REVIEW_XTM;
        const hasQuestionTestCasesReviewAccess = hasQuestionTestCasesAccess();
        const isItemReviewEnabled = Boolean(window.marketplaceProperties.ENABLE_ITEM_REVIEW);
        const isStructureEditorOnQuestion = window.marketplaceProperties.ENABLE_STRUCTURE_EDITOR_ON_QUESTION_EDIT;
        const isNewAuthor2025UI = newAuthorUIService.isNewAuthorUIEnabled();
        const isPreviewSet = hasCURAccessForAction(FeatureTypesWithCurs.PREVIEW_CONTENT);
        const hasItemReviewPermission = (hasCURAccessForAction(FeatureTypesWithCurs.ITEM_REVIEW_ADDITIONAL_RESOURCES)
            || hasCURAccessForAction(FeatureTypesWithCurs.ITEM_REVIEW_METADATA)
            || hasCURAccessForAction(FeatureTypesWithCurs.ANNOTATE_CONTENT)
            || hasCURAccessForAction(FeatureTypesWithCurs.ITEM_REVIEW_STATES)
            || hasCURAccessForAction(FeatureTypesWithCurs.ITEM_REVIEW_ASSOCIATED_CALIBRATION_TEST_EVENTS)
        );
        const isItemReviewSet = (hasItemReviewPermission || hasQuestionTestCasesReviewAccess)
  && (!isNewAuthor2025UI ? !permissionService.hasCurrentUserAccessForReviewingTool() : true);
        const isAuthorEditSet = hasCURAccessForAction(FeatureTypesWithCurs.CONTENT_BLOCK_EDIT) || hasQuestionSetTemplateWriteAccess();
        const hasQuestionSetDesignEditPermission = hasCURAccessForAction(FeatureTypesWithCurs.QUESTION_SET_DESIGN);
        const isCustomUserRolesEnabled = window.marketplaceProperties?.ENABLE_CUSTOM_USER_ROLES;

        if (isNewAuthor2025UI) {
            if (isQuestionMode()) {
                return authorNewEditQuestionSheme(false, isXTMEnabled, isQuestionSet(), isItemReviewEnabled, isIBTemplate,
                    isStructureEditorOnQuestion, { isPreviewSet, isAuthorEditSet });
            }
            return authorEditNewScheme(isTemplate, isXTMEnabled, isQuestionSet(),
                isItemReviewEnabled, {
                    isPreviewSet,
                    isItemReviewSet: !!isItemReviewSet,
                    isAuthorEditSet,
                    hasQuestionSetDesignEditPermission,
                    isCustomUserRolesEnabled,
                });
        }

        if (isQuestionMode()) {
            return authorEditQuestionSheme(false, isXTMEnabled, isQuestionSet(), isItemReviewEnabled, isIBTemplate,
                isStructureEditorOnQuestion, { isPreviewSet, isAuthorEditSet });
        }
        return authorEditScheme(isTemplate, isXTMEnabled, isQuestionSet(), isItemReviewEnabled, {
            isPreviewSet,
            isItemReviewSet: !!isItemReviewSet,
            isAuthorEditSet,
        });
    },
};

export default workspaceSchemeLoadingService;
